import { prefix } from '@root/utils/Lang';

const modulePrefix = 'module.donation';

const translations = {
    'donation': 'Adományozások',

    'newDonation': 'Új adományozás',
    'create.title': "Új adományozás",
    'update.title': "Adományozás szerkesztése",
    'donationCreate': "Új adományozás",

    'name.title': 'Megnevezés',
    'active_from.title': 'Aktív -tól',
    'active_to.title': 'Aktív -ig',
    'cms_url.title': 'Cikk URL-ek',
    'donation_total.title': 'Befolyt összeg',
    'first_donation.title': 'Első adományozás ideje',
    'last_donation.title': 'Utolsó adományozás ideje',
    'round_donated_count.title': 'Kerekítések száma',
    'unique_donated_count.title': 'Egyedi adományok száma',
    'not_donated_count.title': 'Nem adakozott megrendelések száma',
    'dismissed_count.title': 'Véglegesen kikapcsolások száma',
};

export default prefix(modulePrefix, translations);



// WEBPACK FOOTER //
// ./src/modules/Donation/lang/hu.ts